import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import PasswordResetsEditContainer from './PasswordResetsEditContainer'

class PasswordResetsEditPage extends React.Component {

  render() {
    return (
      <PasswordResetsEditContainer location={this.props.location} params={this.props.match.params} />
    );
  }
}

PasswordResetsEditPage.propTypes = {
  // user: PropTypes.object.isRequired,
  // dispatch: PropTypes.func.isRequired
};

PasswordResetsEditPage.contextTypes = {
  router: PropTypes.object.isRequired
}

export default connect()(PasswordResetsEditPage)



// WEBPACK FOOTER //
// ./src/user/PasswordResetsEditPage.js